var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConversationDarkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.993,
    height: 19.5,
    viewBox: "0 0 18.993 19.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_160667",
    "data-name": "Group 160667",
    transform: "translate(-408.368 -224.911)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1050",
    "data-name": "Path 1050",
    d: "M19.544,14.55a1.972,1.972,0,0,1-1.947,2H5.944l-3.884,4v-16a1.972,1.972,0,0,1,1.947-2h13.6a1.972,1.972,0,0,1,1.947,2V10.4",
    transform: "translate(407.058 223.111)",
    fill: "#adc7ff",
    stroke: "#165cf3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_129",
    "data-name": "Ellipse 129",
    cx: 0.516,
    cy: 0.516,
    r: 0.516,
    transform: "translate(426.085 235.1)",
    fill: "#165cf3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_160590",
    "data-name": "Group 160590",
    transform: "translate(412.095 229.324)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1108",
    "data-name": "Rectangle 1108",
    width: 10.172,
    height: 1.359,
    rx: 0.679,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1109",
    "data-name": "Rectangle 1109",
    width: 6.821,
    height: 1.359,
    rx: 0.679,
    transform: "translate(0 3.678)",
    fill: "#f49b31"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConversationDarkIcon);
export default __webpack_public_path__ + "static/media/conversation-dark-icon.29825717d6b3ded9787aea4ea01d71b9.svg";
export { ForwardRef as ReactComponent };